import { ThemeProvider as NextThemesProvider } from "next-themes";

export function ThemeProvider({ children, ...props }) {
    return (
        <NextThemesProvider attribute="class" defaultTheme="light" enableSystem {...props}>
            {children}
        </NextThemesProvider>
    );
}
